import { create } from 'zustand';

const transFormPageIdMap = (pages, pageIdMap = {}) =>
  pages.reduce((pre, cur) => {
    // eslint-disable-next-line no-param-reassign
    pre[cur.pageId] = cur;
    if (cur.subPage) {
      return transFormPageIdMap(Object.values(cur.subPage), pre);
    }
    return pre;
  }, pageIdMap);

const addTopPageInfo = (page, topPage) => {
  // eslint-disable-next-line no-param-reassign
  page.topPageId = topPage.pageId;
  if (page.subPage) {
    Object.values(page.subPage).forEach((subPage) => addTopPageInfo(subPage, topPage));
  }
};

window.__ALL_PAGE_MENU__.forEach((item) => addTopPageInfo(item, item));

export const useSystemStore = create((set) => ({
  allPageConfig: window.__ALL_PAGE_MENU__, // 所有页面配置
  pageId2PageConfig: transFormPageIdMap(window.__ALL_PAGE_MENU__), // 页面 id 到页面信息
  curPagePerm: [], // 当前页面权限
  curPageConfig: {}, // 当前页面信息
  curTopPageConfig: window.__TOP_PAGE_MENU__, // 当前页面顶层信息
  updatePage: (pageConfig) => {
    set((state) => ({
      ...state,
      curPagePerm: pageConfig.resourcePerm,
      curPageConfig: pageConfig,
      curTopPageConfig: state.pageId2PageConfig[pageConfig.topPageId],
    }));
  },
}));

export const useSystemConfig = () =>
  useSystemStore((state) => [
    {
      allPageConfig: state.allPageConfig, // 所有页面配置
      pageId2PageConfig: state.pageId2PageConfig, // 页面 id 到页面信息
      curPagePerm: state.curPagePerm, // 当前页面权限
      curPageConfig: state.curPageConfig, // 当前页面信息
      curTopPageConfig: state.curTopPageConfig, // 当前页面顶层信息
    },
    state.updatePage,
  ]);

export const usePagePerm = () => useSystemStore((state) => state.curPagePerm);
